"use strict";

import Page from "./AccountPermissions.tsx";

export const auth = true;
export const title = "i18n:accountPermissions.pageTitle";
export const Component = Page;
